import Image from 'next/image';
import { KeyboardEvent } from 'react';

import panCardSVG from '@/views/Landing/resources/pan-card.svg';
import Button from '@/lib/Button';
import Input from '@/lib/Input';

export const PanScreenInitial = ({ handleClick }: { handleClick: () => void }): JSX.Element => {
  return (
    <div className="d:flex d:items-center d:flex-col">
      <Image className="ml-6 d:ml-0" src={panCardSVG as string} alt="Pan Card" />
      <div className="my-6 d:text-center">
        <h2 className="font-tasa font-semibold text-2xl mb-1 mr-4">PAN and personal details </h2>
        <p className="text-on-grey-subtle text-base">
          We require your PAN number and address details to verify your identity
        </p>
      </div>
      <Button onClick={handleClick}>Continue</Button>
    </div>
  );
};

export const PanEditComponent = ({
  panError,
  panValue,
  handlePanChange,
  handleKeyDown,
  isLoading,
  handleClick,
}: {
  panError: string;
  panValue: string;
  handlePanChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  isLoading: boolean;
  handleClick: () => void;
}): JSX.Element => {
  return (
    <>
      <h2 className="font-tasa font-semibold text-on-grey-normal text-2xl mb-8">
        What’s your PAN number?
      </h2>
      <div className="d:w-full">
        <Input
          error={panError}
          info="Enter a 10-digit alphanumeric PAN number only"
          placeholder="PAN Number"
          value={panValue}
          onChange={handlePanChange}
          onKeyDown={handleKeyDown}
        />
      </div>
      <div className="mt-3 d:w-full">
        <Button isLoading={isLoading} loadingText="Submitting PAN" onClick={handleClick}>
          Submit PAN
        </Button>
      </div>
    </>
  );
};

export const PanConfirmScreen = ({
  name,
  showPanRetryError,
  panError,
  panInput,
  isCTALoading,
  cancelPayment,
  updatePan,
  editPan,
}: {
  name: string;
  showPanRetryError: boolean;
  panError: string;
  panInput: string;
  isCTALoading: boolean;
  cancelPayment: () => void;
  updatePan: () => void;
  editPan: () => void;
}): JSX.Element => {
  return (
    <div className="d:flex d:flex-col d:items-center d:w-full">
      <Image className="ml-6 d:ml-0" src={panCardSVG as string} alt="Pan Card" />
      <div className="my-6 d:text-center d:w-full">
        <h2 className="font-tasa font-semibold text-2xl mb-1">{name}</h2>
        <p className="text-on-grey-subtle text-base">
          {showPanRetryError ? (
            panError
          ) : (
            <>
              Your given PAN number is <strong>{panInput}</strong>
            </>
          )}
        </p>
      </div>
      <div className="d:w-full">
        {showPanRetryError ? (
          <Button isLoading={isCTALoading} onClick={cancelPayment}>
            Change Payment Method
          </Button>
        ) : (
          <Button isLoading={isCTALoading} onClick={updatePan}>
            Yes, confirm
          </Button>
        )}
        {!showPanRetryError ? (
          <Button className="mt-0" variant="secondary" onClick={editPan}>
            Edit PAN
          </Button>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};
